import { __decorate } from "tslib";
import { customElement, FASTElement, html } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/ChameleonElement';
import styles from './Toolbar.styles.scss';
const template = html `<slot></slot>`;
export const toolbarDefinition = {
    name: 'chameleon-toolbar',
    template,
    styles,
};
let ToolbarComponent = class ToolbarComponent extends ChameleonElementMixin(FASTElement) {
};
ToolbarComponent = __decorate([
    customElement(toolbarDefinition)
], ToolbarComponent);
export { ToolbarComponent };
